import React from "react";
import _get from "lodash/get";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@mui/styles";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { getUsers } from "../../actions/userActions";
import { sorting } from "../../utils/sortingHelpers";
import {LABELS as _LABELS} from "../../language";

const LABELS=_LABELS.settingPage;

const styles = (theme) => ({
});

export class SearchBar extends React.Component {
  state = {
    userId: "all",
  };

  componentDidMount() {
    // this.props.getUsers();
    this.props.getUsers({ skip: 0, limit: 250, status: "ACTIVE" });
  }

  handleChange = (event, name) => {
    this.setState(
      {
        [name]: event.target.value,
      },
      this.searchChange
    );
  };

  searchChange = () => {
    const { userId } = this.state;
    this.props.handleChange({
      userId: userId !== "all" ? userId : null,
    });
  };

  sendMessage = () => {
    this.props.showMessageDialog();
  };

  render() {
    const { classes, users, loading } = this.props;
    const { userId } = this.state;
    const usersArray = sorting(users, "firstName");

    return (
      <AppBar position="static" color="transparent" style={{ marginTop: 10 }}>
        <Toolbar>
          <Grid container spacing={8} alignItems="center">
            <Grid sm={9} item style={{ textAlign: "left" }}>
              <Typography variant="h6" color="inherit">
                <FormControl variant="standard" fullWidth size="small">
                  <InputLabel htmlFor="userId">{LABELS.user}</InputLabel>
                  <Select
                    className={classes.select}
                    value={userId}
                    onChange={(e) => this.handleChange(e, "userId")}
                    inputProps={{
                      name: "userId",
                      id: "userId",
                    }}
                  >
                    <MenuItem value={"all"}>{LABELS.allUser}</MenuItem>
                    {Array.isArray(users) &&
                      usersArray.map((item, i) => (
                        <MenuItem
                          key={i}
                          value={item.id}
                          className={classes.center}
                        >
                          {item.firstName} {item.lastName} <br />
                          {item.email}
                          {` (${item.status})`}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Typography>
            </Grid>
            <Grid sm={3} item style={{ textAlign: "right" }}>
              {/*AutoRefresh
                            <Switch
                                checked={autoRefresh}
                                onChange={this.handleAutoRefresh}
                                value={autoRefresh}
                                color="primary"
                                inputProps={{
                                    "aria-label": "primary checkbox"
                                }}
                            />*/}

              <Button
                disabled={loading}
                variant={"contained"}
                color="primary"
                onClick={this.sendMessage}
                style={{}}
              >
                {loading && (
                  <CircularProgress size={20} style={{ marginRight: 5 }} />
                )}
                {`${LABELS.sendNotification}`}
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    users: _get(state, "userData.users", []),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getUsers }, dispatch);

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(SearchBar)
);
